<template>

  <h3 class="text-center text-base font-semibold leading-8 text-green-400 md:text-left md:text-xl lg:text-xl">
    {{title}}
  </h3>
</template>

<script setup>
defineProps({
  title: String,
})
</script>
